import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";
import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  Sort,
  TabActionDialog, // ADD THIS IMPORT
} from "../types";

const quotationSectionUrl = "/quotations";

export const quotationListPath = quotationSectionUrl;
export enum QuotationListUrlSortField {
  date = "date",
  productName = "productName",
  total = "total",
}
export type QuotationListUrlSort = Sort<QuotationListUrlSortField>;
export type QuotationListUrlDialog = "cancel" | TabActionDialog;
export type QuotationListUrlQueryParams = BulkAction &
  Dialog<QuotationListUrlDialog> &
  QuotationListUrlSort &
  Pagination &
  ActiveTab;

export const quotationListUrl = (params?: QuotationListUrlQueryParams): string => {
  const quotationList = quotationListPath;

  if (params === undefined) {
    return quotationList;
  } else {
    return urlJoin(quotationList, "?" + stringifyQs(params));
  }
};

export const quotationPath = (id: string) => urlJoin(quotationSectionUrl, id);
export const quotationUrl = (id: string, params?: any) =>
  quotationPath(encodeURIComponent(id)) + (params ? "?" + stringifyQs(params) : "");